export const isEllipsisActive = (element) => {
    if (!element) {
        return false;
    }
    return element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth;
};
